export default __webpack_public_path__ + "static/dairy-free-health-3-desktop-9c8c4b4c1ab199baf647cbdad99ec6b9.png";